import { useTranslations } from 'next-intl';
import { useFormContext } from 'react-hook-form';

export const FormErrorLabel = ({ name }: { name: string }) => {
  const form = useFormContext();
  const t = useTranslations('FormErrorLabel');
  if (!form) {
    throw new Error('FormErrorLabel must be used within a FormProvider');
  }
  const err = form.formState.errors[name];
  return (
    <>
      {err && (
        <p className="fieldset-label text-error">
          {
            // TODO: figure out this type madness
            (err.message as string) ||
              // @ts-expect-error this is hard to type properly
              t(err.type)
          }
        </p>
      )}
    </>
  );
};
